__turbopack_context__.v({
  "Description": "CustomerModal-module-scss-module__T8qENa__Description",
  "Form": "CustomerModal-module-scss-module__T8qENa__Form",
  "Image": "CustomerModal-module-scss-module__T8qENa__Image",
  "Modal": "CustomerModal-module-scss-module__T8qENa__Modal",
  "Title": "CustomerModal-module-scss-module__T8qENa__Title",
});
